module.exports = __webpack_public_path__ + "static/media/background.8d7b4f3a.jpg";